import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { PosthogService } from '../../services/posthog.service';
import { UrlParamsPipe } from '../../utilities/url-params.pipe';
import { TalkToSalesButtonComponent } from '../talktosalesButton/talktosalesButton.component';

@Component({
  selector: 'app-common-ready-to',
  templateUrl: './ready-to.component.html',
  styleUrls: ['./ready-to.component.scss'],
  imports: [CommonModule, TalkToSalesButtonComponent, UrlParamsPipe],
})
export class CommonReadyToComponent implements OnInit {
  @Input() readyToData: any;
  @Input() notInside: boolean = false;
  _readyToData:any;
  readyToPanelData:any;
  queryParams: any;
  constructor(
    private route: ActivatedRoute,
    private posthog: PosthogService
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }
  subscriptions: Subscription[];
  ngOnInit(): void {
    this._readyToData = this.readyToData;
  }
  ngOnChanges(): void {
    this._readyToData = this.readyToData;
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  onReadyToCTAClick(): void {
    const action = this._readyToData?.buttons?.[0]?.fields?.buttonText?.toLowerCase().replace(/\s+/g, '_') || 'get_started';
    this.posthog.captureCTAClick(action, 'bottom', {
      ctaText: this._readyToData?.buttons?.[0]?.fields?.buttonText,
      destinationUrl: this._readyToData?.buttons?.[0]?.fields?.redirectLink
    });
  }
}
